var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRteImage = function SvgRteImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.168 10.668 1.83-2.329a1.333 1.333 0 0 1 2.06-.045l1.61 1.874M7.278 8.55c.691-.88 1.655-2.126 1.718-2.207l.006-.008a1.333 1.333 0 0 1 2.056-.04l1.61 1.873m-8.167-5h7c.737 0 1.334.597 1.334 1.333v7c0 .737-.597 1.334-1.334 1.334h-7A1.333 1.333 0 0 1 3.168 11.5v-7c0-.736.597-1.333 1.333-1.333"
  })));
};
export default SvgRteImage;